<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/s156/s156.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">15.6" Center information and passenger Display</div>
                <div class="detail-banner-desc">High NTSC & DCI-P3 dual color gamut.</div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Product Introduction</div>

                    <div class="detail-desc">
                        <div>
                            2.5K high resolution center information and passenger display with in-cell touch solution.
                        </div>
                        <div>
                            Narrow Border and Slim.
                        </div>
                        <div>
                            High luminance and high contrast.
                        </div>
                        <div>
                            High color gamut, can meet both 98% NTSC and 95% DCI-P3.
                        </div>
                        <div>
                            Low Blue Light (Hardware Solution) design for eye-care.
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/s156/s156-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">In-Cell Touch</div>
                                    <div class="k">Touch Solution</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">Edge type</div>
                                    <div class="k">Backlight Technology</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">2560x2x1440</div>
                                    <div class="k">Resolution</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">850nits</div>
                                    <div class="k">Luminance</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1500：1</div>
                                    <div class="k">Contrast</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">LTPS-TFT LCD</div>
                                    <div class="k">Display Technology</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">98%NTSC & 95%DCI-P3</div>
                                    <div class="k">Color Gamut</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
  title: '15.6" Center information and passenger Display - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/electronics/s156.html'

};

import { createApp } from 'vue';
import App from './s156.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./s156.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
